import {
	Component,
	Input,
	OnDestroy,
	OnInit,
	Signal,
	ViewEncapsulation,
	WritableSignal,
	signal,
} from '@angular/core';

interface Scope {
	loading: WritableSignal<boolean>;
}

@Component({
	selector: 'ms-logo',
	templateUrl: './ms-logo.component.html',
	styleUrls: ['./ms-logo.component.scss'],
	encapsulation: ViewEncapsulation.None,
	standalone: false,
})
export class MsLogoComponent implements OnInit, OnDestroy {
	@Input() class: string;
	@Input() image: string;

	scope: Scope = {
		loading: signal(true),
	};

	/**
	 * Constructor
	 */
	constructor() {}

	// -----------------------------------------------------------------------------------------------------
	// @ Lifecycle hooks
	// -----------------------------------------------------------------------------------------------------

	/**
	 * On init
	 */
	ngOnInit(): void {
		this.scope.loading.set(false);
		if (this.class === undefined) {
			this.class = 'w-120 max-w-120';
		}
		if (this.image === undefined) {
			this.image = 'logo.png';
		}
	}

	/**
	 * On destroy
	 */
	ngOnDestroy(): void {}

	// -----------------------------------------------------------------------------------------------------
	// @ Public methods
	// -----------------------------------------------------------------------------------------------------

	// -----------------------------------------------------------------------------------------------------
	// @ Private methods
	// -----------------------------------------------------------------------------------------------------
}
